const PERIOD_PATTERN = /^(\d{4})-?(\d{2})$/;

export function formatTimePeriod(timePeriod: string): string {
  const year = timePeriod.slice(0, 4);
  const month = timePeriod.slice(4, 6);

  return `${year}-${month}`;
}

export function formatSalaryNoticeDisplayPeriod(timePeriod: string): string {
  const trimmedTimePeriod = timePeriod.trim();
  const periodMatch = PERIOD_PATTERN.exec(trimmedTimePeriod);
  if (periodMatch == null) return timePeriod;

  const parsedYear = Number(periodMatch[1]);
  const parsedMonth = Number(periodMatch[2]);
  if (
    !Number.isSafeInteger(parsedYear) ||
    !Number.isSafeInteger(parsedMonth) ||
    parsedMonth < 1 ||
    parsedMonth > 12
  ) {
    return timePeriod;
  }

  const nextMonth = parsedMonth === 12 ? 1 : parsedMonth + 1;
  const nextYear = parsedMonth === 12 ? parsedYear + 1 : parsedYear;

  return `${nextYear}-${String(nextMonth).padStart(2, "0")}`;
}
